import {Type} from "./Type";
import {Photo} from "./Photo";
export class Menu {
	id: number;
	name: string;
	typesList: Array<Type>;
	price: number;
	order: number;
	photo: Photo;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Menu.ts